import { Icons } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { GiftCardTransactionsFragment } from '@/gql/generated';
import { formatNumberToCurrency } from '@/lib/utils';
import { paymentMethods, transactionsType } from '@/utils/constant';
import clsx from 'clsx';
import { ReactNode, useState } from 'react';
import EmailField from '../../_components/email-field';
import MessageField from '../../_components/message-field';
import PrinterReceipt from '../../_components/printer-receipt';
import TopNavigation from '../../_components/top-navigation';
import CashReceiptDetail from '../[id]/_components/cash-receipt-detail';
import ChargeReceiptDetail from '../[id]/_components/charge-receipt-detail';
import GiftCardReceiptDetail from '../[id]/_components/gift-card-receipt-detail';
import ManualReceiptDetail from '../[id]/_components/manual-receipt-detail';

const Item = (props: {
  icon: ReactNode;
  title: string;
  className?: string;
  handleClick: () => void;
}) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-4 rounded-xl border border-gray-border py-10 cursor-pointer',
        props.className,
      )}
      onClick={props.handleClick}
    >
      {props.icon}
      <div className="text-3xl font-bold">{props.title}</div>
    </div>
  );
};

const TransactionReceiptModal = (props: {
  transaction: GiftCardTransactionsFragment;
  onClose: () => void;
}) => {
  const [showReceipt, setShowReceipt] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const paymentMethod = props.transaction.payment_methods?.[0];
  return (
    <>
      <div className="fixed z-[110] w-full h-full bg-white">
        <div className="grid h-screen grid-cols-2 bg-white">
          <div className="flex flex-col border-r border-gray-border p-16">
            <TopNavigation onBack={props.onClose} />
            <div className="flex grow flex-col justify-between pt-14">
              <div className="flex flex-col gap-16">
                <div className="flex flex-col gap-2">
                  <h1 className="text-center text-4xl font-bold">Receipt</h1>
                  <p className="text-center text-2xl">
                    Merchant/ Customer Receipt
                  </p>
                </div>
                <div className="space-y-4">
                  <div className="flex items-center justify-between text-3xl">
                    <span>Amount</span>
                    <span className="font-bold">
                      {props.transaction.type === transactionsType.TOP_UP
                        ? formatNumberToCurrency(props.transaction.price)
                        : formatNumberToCurrency(
                            props.transaction.balance_change,
                          )}
                    </span>
                  </div>

                  <div className="my-5 border-t border-gray-border"></div>
                  <div className="flex items-center justify-between text-3xl">
                    <span>Total</span>
                    <span className="font-bold">
                      {props.transaction.type === transactionsType.TOP_UP
                        ? formatNumberToCurrency(props.transaction.price)
                        : formatNumberToCurrency(
                            props.transaction.balance_change,
                          )}
                    </span>
                  </div>
                </div>
              </div>

              <Button
                className="min-h-20 w-full rounded-xl py-6 text-[28px] font-bold"
                onClick={() => {
                  setShowReceipt(true);
                }}
              >
                View details
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 p-16">
            <PrinterReceipt
              transaction={props.transaction}
              className="flex w-full cursor-pointer flex-col items-center justify-center gap-4 rounded-xl border border-gray-border"
            >
              <div className="flex flex-col items-center justify-center gap-4 py-10">
                <Icons.Print />
                <div className="text-3xl font-bold">Print</div>
              </div>
            </PrinterReceipt>
            <Item
              icon={<Icons.Email />}
              title="Email"
              handleClick={() => setShowEmail(true)}
            />
            <Item
              icon={<Icons.TextMessage />}
              title="Text message"
              handleClick={() => setShowMessage(true)}
            />
          </div>

          {paymentMethod?.type === paymentMethods.CASH && (
            <CashReceiptDetail
              isOpen={showReceipt}
              onClose={() => setShowReceipt(false)}
              data={props.transaction}
            />
          )}

          {paymentMethod?.type === paymentMethods.CHARGE && (
            <ChargeReceiptDetail
              isOpen={showReceipt}
              onClose={() => setShowReceipt(false)}
              data={props.transaction}
            />
          )}
          {paymentMethod?.type === paymentMethods.MANUAL_CARD_ENTRY && (
            <ManualReceiptDetail
              isOpen={showReceipt}
              onClose={() => setShowReceipt(false)}
              data={props.transaction}
            />
          )}
          {props.transaction.type &&
            props.transaction.type === transactionsType.REDEMPTION && (
              <GiftCardReceiptDetail
                isOpen={showReceipt}
                onClose={() => setShowReceipt(false)}
                data={props.transaction}
              />
            )}
        </div>
      </div>
      {showEmail && (
        <EmailField
          id={props.transaction.id}
          onClose={() => setShowEmail(false)}
        />
      )}
      {showMessage && (
        <MessageField
          id={props.transaction.id}
          onClose={() => setShowMessage(false)}
        />
      )}
    </>
  );
};

export default TransactionReceiptModal;
